import type { CSSProperties } from 'react';

/** 12% on-charcoal overlay: the header's one hover lift for controls on charcoal. */
const LIFT = 'color-mix(in srgb, var(--dz-on-charcoal) 12%, var(--dz-charcoal-dim))';
const LIFT_CLEAR = 'color-mix(in srgb, var(--dz-on-charcoal) 12%, transparent)';

const ON_CHARCOAL_TEXT = {
  '--ant-btn-text-color': 'var(--dz-on-charcoal)',
  '--ant-btn-text-color-hover': 'var(--dz-on-charcoal)',
  '--ant-btn-text-color-active': 'var(--dz-on-charcoal)',
};

/**
 * antd v6 paints a Button from `--ant-btn-*` vars. Setting them inline restyles every
 * state (rest, hover, active) without out-gunning antd's hover selectors, and keeps
 * antd's focus-visible outline — the same ring the nav links get.
 */
export const HEADER_BUTTON_STYLES = {
  avatar: {
    ...ON_CHARCOAL_TEXT,
    '--ant-btn-bg-color': 'var(--dz-charcoal-dim)',
    '--ant-btn-bg-color-hover': LIFT,
    '--ant-btn-bg-color-active': LIFT,
    '--ant-btn-border-color': 'var(--dz-bright-blue)',
    '--ant-btn-border-color-hover': 'var(--dz-bright-blue)',
    '--ant-btn-border-color-active': 'var(--dz-bright-blue)',
  } as CSSProperties,
  navMenu: {
    ...ON_CHARCOAL_TEXT,
    '--ant-btn-bg-color-hover': LIFT_CLEAR,
    '--ant-btn-bg-color-active': LIFT_CLEAR,
  } as CSSProperties,
} satisfies Record<string, CSSProperties>;
